import React from "react";

const NotFound = () => {
  return (
    <div>
      <img
        src="https://miro.medium.com/max/1400/1*dH58ZpeVOaNehc-JO-RIPw.png"
        alt=""
      />
    </div>
  );
};

export default NotFound;
